export default class ScrollToBottomComponent {
    private container: HTMLElement;
    private observer: MutationObserver;
    private debounceTimeout: number | null = null;

    constructor(container: HTMLElement) {
        this.container = container;
        this.observer = new MutationObserver(() => this.checkOverflow());
        this.init();
    }

    private init() {
        this.checkOverflow();
        this.container.addEventListener('scroll', () => this.debounce(this.handleScroll.bind(this), 100));
        this.observer.observe(this.container, { childList: true, subtree: true });
    }

    private checkOverflow() {
        if (this.container.scrollHeight > this.container.clientHeight) {
            this.appendScrollButton();
        } else {
            this.removeScrollButton();
        }
    }

    private appendScrollButton() {
        if (!this.container.querySelector('.scroll-to-bottom')) {
            this.renderHTML();
            const scrollButton = this.container.querySelector('.scroll-to-bottom button');
            if (scrollButton) {
                scrollButton.addEventListener('click', () => {
                    this.container.scrollTop = this.container.scrollHeight;
                    this.removeScrollButton();
                });
            }
        }
    }

    private removeScrollButton() {
        const scrollButton = this.container.querySelector('.scroll-to-bottom');
        if (scrollButton) {
            this.observer.disconnect();
            scrollButton.remove();
            this.observer.observe(this.container, { childList: true, subtree: true });
        }
    }

    private handleScroll() {
        const margin = 10;
        if (this.container.scrollTop + this.container.clientHeight >= this.container.scrollHeight - margin) {
            this.removeScrollButton();
        } else {
            this.appendScrollButton();
        }
    }

    private debounce(func: () => void, wait: number) {
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        this.debounceTimeout = window.setTimeout(func, wait);
    }

    public generateHtmlContent(): string {
        return `
        <div class="scroll-to-bottom">
            <button>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-md text-token-text-primary">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071L4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929C4.68342 11.9024 5.31658 11.9024 5.70711 12.2929L11 17.5858V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V17.5858L18.2929 12.2929C18.6834 11.9024 19.3166 11.9024 19.7071 12.2929C20.0976 12.6834 20.0976 13.3166 19.7071 13.7071L12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21Z" fill="#FFF"></path>
                </svg>
            </button>
        </div>
    `.replace(/\s\s+/g, '').trim();
    }

    private renderHTML() {
        this.container.insertAdjacentHTML('beforeend', this.generateHtmlContent());
    }
}